import config from '@/config/global'

export default {
  install (Vue) {
    let configLocal = {}
    if (process.env.NODE_ENV !== 'production') {
      try {
        configLocal = require('@/config/global-local.js').default
      } catch (_) {
        // eslint-disable-next-line
      }
      Object.keys(configLocal).forEach(key => {
        config[key] = configLocal[key]
      })
    }
    Vue.fpConfig = Vue.prototype.$fpConfig = config
  }
}
